<template>
    <v-card width="580" height="310" v-if="$store.state.showCopyFile2" style="background-color: #F2F2F2;">
        <v-snackbar top v-model="snackbar" :color="snackbarColor" timeout="2000">{{snackbarInfo}}</v-snackbar>
        <div style="display: flex;margin: 14px 15px 5px;">
            <div class="title-font">下载</div>
            <v-spacer></v-spacer>
            <v-icon @click="closePanel">mdi-close</v-icon>
        </div>
        <div class="line-style"></div>
        <div>
            <div class="title-span">
                <span>
                    {{$store.state.fileName}}
                </span>
                <span>
                    (可下载
                    <span style="color: red;font-weight: bold;">{{$store.state.fileNum}}</span>
                    个文件
                    <span v-if="!$store.state.isFolder">，
                        <span style="color: red;font-weight: bold;">{{size}}</span>{{unit}}
                    </span>)
                </span>
            </div>
            <div v-show="!noneFolderFile" style="margin-top: 20px;">
                <v-text-field solo v-model="url" style="font-size: 14px;margin: 0px 17px;"></v-text-field>
            </div>
            <div style="display: flex;justify-content: center;">
                <div v-if="url !== ''" style="display: flex;">
                    <v-btn
                            depressed :disabled="noneFolderFile" width="94" height="36" style="font-size: 12px;background-color: #7FA4FB;color: #FFFFFF;"
                            v-clipboard:copy="url" v-clipboard:success="copySuccess" v-clipboard:error="copyError" @click="copyUrl"
                    >复制</v-btn>
                    <v-btn
                            depressed v-if="$store.state.fileNum===1" @click="download"
                            style="font-size: 12px;background-color: #7FA4FB;margin-left: 67px;color: #FFFFFF;" width="94" height="36"
                    >立即下载</v-btn>
                </div>
              <div v-else>
                 <span style="color:red">链接已过期，请联系商务经理</span>
              </div>
            </div>
            <div style="color: #888888;font-size: 12px;margin: 15px 20px;">
                对于整个<<b>文件夹</b>>下载，仅支持<b>复制下载链接</b>，可复制到<b>迅雷</b>等下载器中批量下载；对于<<b>单个文件</b>>下载，支持<b>复制下载链接</b>及<b>浏览器直接下载</b>
            </div>
        </div>
    </v-card>
</template>
<script>
    export default {
        name: "CopyFile",
        data(){
            return {
                snackbar: false, snackbarInfo: "", snackbarColor: "",
                size: 0, unit: "",
                noneFolderFile: false,  // 只有通过文件夹右侧跳转，且数据为空时为true
                url: "",
            }
        },
        mounted() {
            if (this.$store.state.fileNum !== 0) {
                this.url = this.$store.state.fileLink.join("\n");
            }
            this.cleanData();
        },
        methods: {
            download(){
                let link = document.createElement('a')
                link.setAttribute('download', '')
                link.href = this.url;
                link.click();
            },
          copyUrl(){
            if (this.selectedUrl !== undefined && this.selectedUrl.length > 0){
              for (let i = 0; i < this.selectedUrl.length; i++) {
                console.log('我看戏' + JSON.stringify(this.selectedUrl[i]))
                this.updateDownloadStatus(this.selectedUrl[i])
              }
            }else{
              console.log('我看戏22' + JSON.stringify(this.$store.state.item))
            }

          },
          updateDownloadStatus(item){
            console.log("状态需要更新" + JSON.stringify(item))
            var param = new FormData();
            param.append("productCode", item.productCode)
            this.axios.post("/demandService/pan/downloadSyn", param)
              .then(res => {
                console.log("接口返回结果" + res)
              })
            // todo 可能需要改成响应式更新
            item.isDownload = true
          },
            copySuccess() {
                this.snackbarColor="success"
                this.snackbarInfo = "已复制到剪切板"
                this.snackbar = true;
            },
            copyError() {
                this.snackbarColor="error"
                this.snackbarInfo = "复制失败"
                this.snackbar = true;
            },
            cleanData(){
                if (!this.$store.state.isFolder) {
                    // 压缩包
                    this.noneFolderFile = false;
                    if (this.$store.state.fileSize >= 1000000000) {
                        this.size = (this.$store.state.fileSize/1000000000).toFixed(2);
                        this.unit = "GB";
                    } else if (this.$store.state.fileSize >= 1000000) {
                        this.size = (this.$store.state.fileSize/1000000).toFixed(2);
                        this.unit = "MB";
                    } else if (this.$store.state.fileSize >= 1000) {
                        this.size = (this.$store.state.fileSize/1000).toFixed(2);
                        this.unit = "KB";
                    } else{
                        this.size = this.$store.state.fileSize;
                        this.unit = "B";
                    }
                } else {
                    if (this.$store.state.fileNum === 0){
                        this.noneFolderFile = true;
                    } else {
                        this.noneFolderFile = false;
                    }
                }
            },
            closePanel(){
                this.$store.state.showCopyFile = false;
                this.$store.state.fileNum = 0;
                this.$store.state.fileLink = [];
                this.$store.state.isFolder = false;
                this.$store.state.fileName = "";
                this.$store.state.fileSize = 0;
                this.$store.state.showOriginImage = false;
                this.$store.state.bifProductId = "";
                this.$store.state.isDownloadUrl = false;
            }
        }
    }
</script>
<style scoped>
    .title-font {
        font-size: 14px;
        color: #101010;
    }
    .line-style {
        height: 1px;
        width: 530px;
        background-color: #DFDFDF;
        margin: 5px 15px;
    }
    .title-span {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        margin-top: 10px;
        font-size: 14px;
        color: #4B4B4B;
    }
</style>